// section 1 - Plant & Production Information (subCategory 2)

export const reportingPeriodKeys = {
  REPORTING_PERIOD_QUESTION_1_1_1: 'reportingPeriodQuestion111',
  REPORTING_PERIOD_QUESTION_1_1_2: 'reportingPeriodQuestion112'
};

export const installationLocationKeys = {
  INSTALLATION_LOCATION_QUESTION_1_2_1: 'installationLocationQuestion121',
  INSTALLATION_LOCATION_QUESTION_1_2_2: 'installationLocationQuestion122',
  INSTALLATION_LOCATION_QUESTION_1_2_3: 'installationLocationQuestion123',
  INSTALLATION_LOCATION_QUESTION_1_2_4: 'installationLocationQuestion124',
  INSTALLATION_LOCATION_QUESTION_1_2_5: 'installationLocationQuestion125',
  INSTALLATION_LOCATION_QUESTION_1_2_6: 'installationLocationQuestion126'
};

export const geographicCoordinatesKeys = {
  GEOGRAPHIC_COORDINATES_QUESTION_1_3_1: 'geographicCoordinatesQuestion131',
  GEOGRAPHIC_COORDINATES_QUESTION_1_3_2: 'geographicCoordinatesQuestion132',
  GEOGRAPHIC_COORDINATES_QUESTION_1_3_3: 'geographicCoordinatesQuestion133'
};

export const economicActivityKeys = {
  ECONOMIC_ACTIVITY_QUESTION_1_4_1: 'economicActivityQuestion141'
};

export const verificationKeys = {
  VERIFICATION_QUESTION_1_5_1: 'verificationQuestion151',
  VERIFICATION_QUESTION_1_5_2: 'verificationQuestion152',
  VERIFICATION_QUESTION_1_5_3: 'verificationQuestion153',
  VERIFICATION_QUESTION_1_5_4: 'verificationQuestion154'
};

export const processSetupKeys = {
  PROCESS_SETUP_QUESTION_1_6_1_A: 'processSetupQuestion161_A',
  PROCESS_SETUP_QUESTION_1_6_2_A: 'processSetupQuestion162_A',
  PROCESS_SETUP_QUESTION_1_6_3_A: 'processSetupQuestion163_A',
  PROCESS_SETUP_QUESTION_1_6_4_A: 'processSetupQuestion164_A',
  PROCESS_SETUP_QUESTION_1_6_5_A: 'processSetupQuestion165_A',
  PROCESS_SETUP_QUESTION_1_6_6_A: 'processSetupQuestion166_A',
  PROCESS_SETUP_QUESTION_1_6_7_A: 'processSetupQuestion167_A',
  PROCESS_SETUP_QUESTION_1_6_8_A: 'processSetupQuestion168_A',

  PROCESS_SETUP_QUESTION_1_6_1_B: 'processSetupQuestion161_B',
  PROCESS_SETUP_QUESTION_1_6_2_B: 'processSetupQuestion162_B',
  PROCESS_SETUP_QUESTION_1_6_3_B: 'processSetupQuestion163_B',
  PROCESS_SETUP_QUESTION_1_6_4_B: 'processSetupQuestion164_B',
  PROCESS_SETUP_QUESTION_1_6_5_B: 'processSetupQuestion165_B',
  PROCESS_SETUP_QUESTION_1_6_6_B: 'processSetupQuestion166_B',
  PROCESS_SETUP_QUESTION_1_6_7_B: 'processSetupQuestion167_B',
  PROCESS_SETUP_QUESTION_1_6_8_B: 'processSetupQuestion168_B',
  PROCESS_SETUP_QUESTION_1_6_9_B: 'processSetupQuestion169_B'
};

export const precursorSetupKeys = {
  PRECURSOR_SETUP_QUESTION_1_7_1: 'precursorSetupQuestion171',
  PRECURSOR_SETUP_QUESTION_1_7_2: 'precursorSetupQuestion172',
  PRECURSOR_SETUP_QUESTION_1_7_3: 'precursorSetupQuestion173',
  PRECURSOR_SETUP_QUESTION_1_7_4: 'precursorSetupQuestion174',
  PRECURSOR_SETUP_QUESTION_1_7_5: 'precursorSetupQuestion175',
  PRECURSOR_SETUP_QUESTION_1_7_6: 'precursorSetupQuestion176',
  PRECURSOR_SETUP_QUESTION_1_7_7: 'precursorSetupQuestion177',
  PRECURSOR_SETUP_QUESTION_1_7_8: 'precursorSetupQuestion178',
  PRECURSOR_SETUP_QUESTION_1_7_9: 'precursorSetupQuestion179'
};

export const authorizedRepresentativeKeys = {
  AUTHORIZED_REP_QUESTION_1_8_1: 'authorizedRepresentativeQuestion181',
  AUTHORIZED_REP_QUESTION_1_8_2: 'authorizedRepresentativeQuestion182',
  AUTHORIZED_REP_QUESTION_1_8_3: 'authorizedRepresentativeQuestion183'
};

export const ProductComplianceKeys = {
  PRODUCT_COMPLIANCE_QUESTION_1_9_1: 'ProductComplianceQuestion191',
  PRODUCT_COMPLIANCE_QUESTION_1_9_2: 'ProductComplianceQuestion192',
  PRODUCT_COMPLIANCE_QUESTION_1_9_3: 'ProductComplianceQuestion193'
};

// Section 2

export const sourceStreamKeys = {
  SOURCE_STREAM_QUESTION_2_1_1: 'sourceStreamQuestion211',
  SOURCE_STREAM_QUESTION_2_1_1_1: 'sourceStreamQuestion211_1',
  SOURCE_STREAM_QUESTION_2_1_1_2: 'sourceStreamQuestion211_2',
  SOURCE_STREAM_QUESTION_2_1_1_3: 'sourceStreamQuestion211_3'
};

export const monitoringMethodologyKeys = {
  MONITORING_METHODOLOGY_QUESTION_2_2_1: 'monitoringMethodologyQuestion221',
  MONITORING_METHODOLOGY_QUESTION_2_2_2: 'monitoringMethodologyQuestion222'
};

export const activityDataKeys = {
  ACTIVITY_DATA_QUESTION_2_3_1: 'activityDataQuestion231',
  ACTIVITY_DATA_QUESTION_2_3_1_1: 'activityDataQuestion231_1',
  ACTIVITY_DATA_QUESTION_2_3_1_2: 'activityDataQuestion231_2',
  ACTIVITY_DATA_QUESTION_2_3_1_3: 'activityDataQuestion231_3',
  ACTIVITY_DATA_QUESTION_2_3_1_4: 'activityDataQuestion231_4',
  ACTIVITY_DATA_QUESTION_2_3_1_5: 'activityDataQuestion231_5',
  ACTIVITY_DATA_QUESTION_2_3_1_6: 'activityDataQuestion231_6',
  ACTIVITY_DATA_QUESTION_2_3_1_7: 'activityDataQuestion231_7'
};

// export const emissionFactorsKeys = {
//   EMISSION_FACTORS_QUESTION_2_4_1: 'emissionFactorsQuestion241',
//   EMISSION_FACTORS_QUESTION_2_4_2: 'emissionFactorsQuestion242',
//   EMISSION_FACTORS_QUESTION_2_4_3: 'emissionFactorsQuestion243'
// };

// export const biomassKeys = {
//   BIOMASS_QUESTION_2_5_1: 'biomassQuestion251',
//   BIOMASS_QUESTION_2_5_2: 'biomassQuestion252'
// };

// export const carbonAndQualityKeys = {
//   CARBON_AND_QUALITY_QUESTION_2_6_1: 'carbonAndQualityQuestion261',
//   CARBON_AND_QUALITY_QUESTION_2_6_2: 'carbonAndQualityQuestion262'
// };

// SECTION 3
export const fuelAllocationKeys = {
  FUEL_ALLOCATION_QUESTION_3_1_1: 'fuelAllocationQuestion311',
  FUEL_ALLOCATION_QUESTION_3_1_1_1: 'fuelAllocationQuestion311_1',

  FUEL_ALLOCATION_QUESTION_3_1_2: 'fuelAllocationQuestion312',
  FUEL_ALLOCATION_QUESTION_3_1_2_1: 'fuelAllocationQuestion312_1'
};

export const monitoringApproachKeys = {
  MONITORING_APPROACH_QUESTION_3_2_1: 'monitoringApproachQuestion321',
  MONITORING_APPROACH_QUESTION_3_2_2: 'monitoringApproachQuestion322',
  MONITORING_APPROACH_QUESTION_3_2_3: 'monitoringApproachQuestion323'
};

export const electricityKeys = {
  ELECTRICITY_QUESTION_3_3_1: 'electricityQuestion331',
  ELECTRICITY_QUESTION_3_3_2: 'electricityQuestion332',
  ELECTRICITY_QUESTION_3_3_3: 'electricityQuestion333',
  ELECTRICITY_QUESTION_3_3_4: 'electricityQuestion334'
};

export const emissionFactorsAndCHPKeys = {
  EMISSION_FACTORS_AND_CHP_QUESTION_3_4_1: 'emissionFactorsAndCHPQuestion341',
  EMISSION_FACTORS_AND_CHP_QUESTION_3_4_2: 'emissionFactorsAndCHPQuestion342',
  EMISSION_FACTORS_AND_CHP_QUESTION_3_4_3: 'emissionFactorsAndCHPQuestion343',
  EMISSION_FACTORS_AND_CHP_QUESTION_3_4_4: 'emissionFactorsAndCHPQuestion344'
};

// SECTION 4
export const processIdentificationKeys = {
  PROCESS_IDENTIFICATION_QUESTION_4_1_1: 'processIdentificationQuestion411',
  PROCESS_IDENTIFICATION_QUESTION_4_1_2: 'processIdentificationQuestion412',
  PROCESS_IDENTIFICATION_QUESTION_4_1_3: 'processIdentificationQuestion413',
  PROCESS_IDENTIFICATION_QUESTION_4_1_4: 'processIdentificationQuestion414',
  PROCESS_IDENTIFICATION_QUESTION_4_1_5: 'processIdentificationQuestion415'
};

export const chemicalCompositionKeys = {
  CHEMICAL_COMPOSITION_QUESTION_4_2_1: 'chemicalCompositionQuestion421',
  CHEMICAL_COMPOSITION_QUESTION_4_2_2: 'chemicalCompositionQuestion422',
  CHEMICAL_COMPOSITION_QUESTION_4_2_3: 'chemicalCompositionQuestion423',
  CHEMICAL_COMPOSITION_QUESTION_4_2_4: 'chemicalCompositionQuestion424',
  CHEMICAL_COMPOSITION_QUESTION_4_2_5: 'chemicalCompositionQuestion425',
  CHEMICAL_COMPOSITION_QUESTION_4_2_6: 'chemicalCompositionQuestion426',
  CHEMICAL_COMPOSITION_QUESTION_4_2_7: 'chemicalCompositionQuestion427',
  CHEMICAL_COMPOSITION_QUESTION_4_2_8: 'chemicalCompositionQuestion428'
};

export const productionKeys = {
  PRODUCTION_QUESTION_4_3_1: 'productionQuestion431',
  PRODUCTION_QUESTION_4_3_2: 'productionQuestion432',
  PRODUCTION_QUESTION_4_3_3: 'productionQuestion433'
};

export const fuelInputsKeys = {
  FUEL_INPUTS_QUESTION_4_4_1: 'fuelInputsQuestion441',
  FUEL_INPUTS_QUESTION_4_4_2: 'fuelInputsQuestion442'
};

export const energyBalanceKeys = {
  ENERGY_BALANCE_QUESTION_4_5_1: 'energyBalanceQuestion451',
  ENERGY_BALANCE_QUESTION_4_5_2: 'energyBalanceQuestion452',
  ENERGY_BALANCE_QUESTION_4_5_3: 'energyBalanceQuestion453'
};

export const wasteGasKeys = {
  WASTE_GAS_QUESTION_4_6_1: 'wasteGasQuestion461',
  WASTE_GAS_QUESTION_4_6_2: 'wasteGasQuestion462',
  WASTE_GAS_QUESTION_4_6_3: 'wasteGasQuestion463',
  WASTE_GAS_QUESTION_4_6_4: 'wasteGasQuestion464',
  WASTE_GAS_QUESTION_4_6_5: 'wasteGasQuestion465'
};

export const scrapAndElectricityKeys = {
  SCRAP_AND_ELECTRICITY_QUESTION_4_7_1: 'scrapAndElectricityQuestion471',
  SCRAP_AND_ELECTRICITY_QUESTION_4_7_2: 'scrapAndElectricityQuestion472',
  SCRAP_AND_ELECTRICITY_QUESTION_4_7_3: 'scrapAndElectricityQuestion473'
};

export const carbonCaptureKeys = {
  CARBON_CAPTURE_QUESTION_4_8_1: 'carbonCaptureQuestion481',
  CARBON_CAPTURE_QUESTION_4_8_2: 'carbonCaptureQuestion482'
};

// SECTION 5
export const precursorIdentificationKeys = {
  PRECURSOR_IDENTIFICATION_QUESTION_5_1_1: 'precursorIdentificationQuestion511',
  PRECURSOR_IDENTIFICATION_QUESTION_5_1_2: 'precursorIdentificationQuestion512'
};

export const originKeys = {
  ORIGIN_QUESTION_5_2_1: 'originQuestion521',
  ORIGIN_QUESTION_5_2_2: 'originQuestion522'
};

export const emissionsKeys = {
  EMISSIONS_QUESTION_5_3_1: 'emissionsQuestion531',
  EMISSIONS_QUESTION_5_3_2: 'emissionsQuestion532',
  EMISSIONS_QUESTION_5_3_3: 'emissionsQuestion533'
};

export const dataVerificationKeys = {
  DATA_VERIFICATION_QUESTION_5_4_1: 'dataVerificationQuestion541',
  DATA_VERIFICATION_QUESTION_5_4_2: 'dataVerificationQuestion542'
};

// SECTION 6
export const carbonTaxStatusKeys = {
  CARBON_TAX_STATUS_QUESTION_6_1_1: 'carbonTaxStatusQuestion611'
};

export const taxDetailsKeys = {
  TAX_DETAILS_QUESTION_6_2_1: 'taxDetailsQuestion621',
  TAX_DETAILS_QUESTION_6_2_2: 'taxDetailsQuestion622',
  TAX_DETAILS_QUESTION_6_2_3: 'taxDetailsQuestion623'
};

export const paymentKeys = {
  PAYMENT_QUESTION_6_3_1: 'paymentQuestion631',
  PAYMENT_QUESTION_6_3_2: 'paymentQuestion632',
  PAYMENT_QUESTION_6_3_3: 'paymentQuestion633'
};

export const coverageAndProofKeys = {
  COVERAGE_AND_PROOF_QUESTION_6_4_1: 'coverageAndProofQuestion641',
  COVERAGE_AND_PROOF_QUESTION_6_4_2: 'coverageAndProofQuestion642',
  COVERAGE_AND_PROOF_QUESTION_6_4_3: 'coverageAndProofQuestion643'
};

// section 7

export const customerMRNNumberKeys = {
  CUSTOMER_MRN_QUESTION_7_1_1: 'customerMRNNumberQuestion711',
  CUSTOMER_MRN_QUESTION_7_1_2: 'customerMRNNumberQuestion712',
  CUSTOMER_MRN_QUESTION_7_1_3: 'customerMRNNumberQuestion713'
};

export const customerLogisticsKeys = {
  LOGISTICS_QUESTION_7_2_1: 'logisticsQuestion721',
  LOGISTICS_QUESTION_7_2_2: 'logisticsQuestion722',
  LOGISTICS_QUESTION_7_2_3: 'logisticsQuestion723'
};
